var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone-fill"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#CF3819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6053 37.1848L13.0425 34.6219C12.6619 34.2414 12.6404 33.6315 12.9931 33.2252C13.2877 32.8857 13.5352 32.616 13.7354 32.4157C20.14 26.0112 30.5237 26.0112 36.9283 32.4157C37.1285 32.616 37.376 32.8858 37.6706 33.2252C38.0232 33.6315 38.0017 34.2414 37.6213 34.6218L35.0583 37.1848C34.8722 37.3709 34.5755 37.3858 34.3717 37.2194C34.1888 37.07 34.0398 36.9521 33.9247 36.8659C32.7542 35.9886 31.4802 35.3135 30.1504 34.8406C29.9369 34.7647 29.8086 34.5467 29.8458 34.3232L30.2927 31.6415C27.1158 30.3693 23.5479 30.3692 20.371 31.6414L20.8172 34.3184C20.8548 34.5446 20.7249 34.7652 20.509 34.8421C19.1796 35.3153 17.906 35.9907 16.736 36.8682C16.6216 36.9538 16.4736 37.071 16.2919 37.2193C16.0881 37.3857 15.7914 37.3708 15.6053 37.1848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9661 12C26.6454 12 27.1961 12.5507 27.1961 13.23V21.8399C27.1961 22.5192 26.6454 23.0699 25.9661 23.0699C25.2868 23.0699 24.7361 22.5192 24.7361 21.8399V13.23C24.7361 12.5507 25.2868 12 25.9661 12ZM14.6932 14.5019C15.3494 14.3261 16.0238 14.7155 16.1996 15.3716L18.428 23.6882C18.6038 24.3443 18.2145 25.0188 17.5583 25.1946C16.9021 25.3704 16.2277 24.981 16.0519 24.3248L13.8235 16.0083C13.6476 15.3521 14.037 14.6777 14.6932 14.5019ZM37.239 14.5019C37.8952 14.6777 38.2846 15.3521 38.1088 16.0083L35.8804 24.3248C35.7045 24.981 35.0301 25.3704 34.3739 25.1946C33.7178 25.0188 33.3284 24.3443 33.5042 23.6882L35.7326 15.3716C35.9084 14.7155 36.5829 14.3261 37.239 14.5019Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFill);
export default __webpack_public_path__ + "static/media/phone-fill.0f5a1f9af8ffff5b0e29bb3384327404.svg";
export { ForwardRef as ReactComponent };